import React, { useEffect } from "react";
import clsx from "clsx";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { actionCreators } from "../Login/action";
import { actionCreators as projectActionCreators } from "../Project/action";
import { isLocalHost } from '../../helpers/isLocalHost';
import { useStyles } from './style';
import isPWA from './../../helpers/isPWA';
import PageWrapper from '../PageWrapper';


const Page = props => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [test, setTest] = React.useState(false);
  
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const fixedHeightPaper = clsx(classes.paper);

  const fixedHeightPaperMore = clsx(classes.paper, classes.fixedHeightMore);

  const [width, setWidth] = React.useState(window.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth({ width: window.innerWidth });
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
  });

  useEffect(() => {
    if (window.innerWidth <= 1000) {
      setOpen(false);
    }
    window.removeEventListener("resize", handleWindowSizeChange);
    
    document.oncontextmenu = (e) => {
      
      if (!isLocalHost && e.button === 2) {
          e.preventDefault();
          return false;
      }
    }

  }, []);

  const isStandalone = isPWA;

  const isMobile = isStandalone || width <= 1328 || width.width <= 1328;

  return (
  <PageWrapper {...props}> 
      <Grid container spacing={3}>
      <Grid item xs={12} md={12} lg={12}>
        {isMobile ? (
          props.children
        ) : (
          <Paper className={fixedHeightPaper}>{props.children}</Paper>
        )}
      </Grid>
    </Grid>
   
  </PageWrapper>);
};

const mapStateToProps = (state, props) => {
  return {
    isFormIsOpen: state.isFormIsOpen.isFormIsOpen,
    isEditFormIsOpen: state.isFormIsOpen.isEditFormIsOpen,
    initialForm: state.isFormIsOpen.initialForm,
    uid: state.user && state.user.user.uid,
    isProjectDone:
      state.tasks &&
      props.projectId &&
      state.tasks[props.projectId] &&
      state.tasks[props.projectId].done,
    projectName:
      state.tasks &&
      props.projectId &&
      state.tasks[props.projectId] &&
      state.tasks[props.projectId].title,
    userName: state.user && state.user.user.displayName,
    userPhotoURL: state.user && state.user.user.photoURL,
    counterDone:
      state.tasks &&
      Object.keys(state.tasks).filter(task => state.tasks[task].done).length
  };
};

export default connect(mapStateToProps, {
  ...actionCreators,
  ...projectActionCreators
})(Page);
